export default __webpack_public_path__ + "static/media/questionBankIcon.2072006a.png";